import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type UpdatePackagingTypesMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdatePackagingTypesInput;
}>;

export type UpdatePackagingTypesMutationResult = { __typename?: 'Mutation' } & {
  updatePackagingTypes: { __typename?: 'UpdatePackagingTypesPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdatePackagingTypesDocument = gql`
  mutation updatePackagingTypes($input: UpdatePackagingTypesInput!) {
    updatePackagingTypes(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
